import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { BaseURL } from '../BaseData';
import styles from './InteraktivXizmatlar.module.css';

const InteraktivXizmatlar = () => {
    const { t } = useTranslation();
    const [botData, setBotData] = useState(null);

    useEffect(() => {
        const fetchBotData = async () => {
            try {
                const response = await axios.get(`${BaseURL}api/telegram-bot/`);
                if (response.data && response.data.length > 0) {
                    setBotData(response.data[0]);
                }
            } catch (error) {
                console.error("Error fetching bot data:", error);
            }
        };
        fetchBotData();
    }, []);
    return (
        <div className={styles.mainContainer}>
            <div className={styles.container}>
                <div className={styles.titleWrapper}>
                    <h2
                        className={styles.title}
                        dangerouslySetInnerHTML={{ __html: t("interactive_title") }}
                    />
                </div>

                <div className={styles.contentBox}>
                    <div className={styles.videoContainer}>
                        <video
                            className={styles.botVideo}
                            controls
                            src={botData?.video ? botData.video : "/bot.MP4"}
                        >
                            {t("sorry")}
                        </video>
                    </div>

                    <div className={styles.actionContainer}>
                        <a href={botData?.link ? botData.link : "https://t.me/renessans_talim_bot"} target="_blank" rel="noopener noreferrer" className={styles.botButton}>
                            {t("go_to_bot")}
                        </a>
                    </div>

                    <p className={styles.paragraph}>
                        {t("interactive_description1")}
                    </p>

                    <p className={styles.paragraph}>
                        {t("interactive_description2")}
                    </p>

                    <ul className={styles.serviceList}>
                        <li>📌 {t("service_contract")}</li>
                        <li>📌 {t("service_reference")}</li>
                        <li>📌 {t("service_hemis")}</li>
                        <li>📌 {t("service_transcript")}</li>
                        <li>📌 {t("service_call_paper")}</li>
                        <li>📌 {t("service_buildings")}</li>
                        <li>📌 {t("service_schedule")}</li>
                    </ul>

                    <p className={styles.highlightParagraph}>
                        {t("interactive_hint")}
                    </p>

                    <p className={styles.finalParagraph}>
                        {t("interactive_footer")}
                    </p>

                </div>
            </div>
        </div>
    );
};

export default InteraktivXizmatlar;
